import { AgGridFooterActions } from "@/pages/eaf/data-entry/components/tables/components/AgGridFooterActions";
import { ErrorModal } from "@dexteel/mesf-core";
import { Box, Divider, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { useCastersContext } from "../../../CastersContext";
import { useTableStyles } from "../../../styles/useTableStyles";
import { useLostStrandActions } from "./hooks/useLostStrandActions";
import { useLostStrandTableData } from "./hooks/useLostStrandTableData";
import { UpsertDeleteLostStrand } from "./modals/UpsertDeleteLostStrand";

interface Props {
	refreshData: Function;
}

export const LostStrandTable = ({ refreshData }: Props) => {
	const {
		state: { processData, lostStrands },
		actions,
	} = useCastersContext();

	const [error, setError] = useState<string | null>(null);
	const [modalMode, setModalMode] = useState<
		"create" | "edit" | "delete" | null
	>(null);

	const [selectedLostStrand, setSelectedLostStrand] = useState<any>();
	const classes = useTableStyles();

	const { onEditButtonClick, onDeleteButtonClick, readFromPLC } =
		useLostStrandActions({
			setLostStrandSelected: setSelectedLostStrand,
			setModalMode,
			refreshData,
			setError,
		});

	const { columns } = useLostStrandTableData({
		onEditButtonClick,
		onDeleteButtonClick,
	});

	return (
		<>
			<Paper elevation={0}>
				<Box className={` ${classes.borderAgGridTable} `}>
					<div
						className={`${classes.materialTable}`}
						style={{ height: "11rem" }}
					>
						<AgGridReact
							rowSelection="single"
							suppressRowClickSelection={true}
							pagination={false}
							singleClickEdit={false}
							tooltipShowDelay={0}
							tooltipHideDelay={2000}
							rowData={lostStrands}
							columnDefs={columns}
							domLayout="normal"
						/>
					</div>
					<Divider />
					<AgGridFooterActions
						hasMaxItems={false}
						showCreateModal={modalMode === "create"}
						setShowCreateModal={() => {
							setModalMode("create");
							actions.setRefreshInPause(true);
						}}
						table="lost-strands"
						readFromPLC={readFromPLC}
					/>
				</Box>
			</Paper>
			<UpsertDeleteLostStrand
				show={modalMode}
				onHide={() => {
					actions.setRefreshInPause(false);
					setModalMode(null);
					setSelectedLostStrand(null);
					refreshData();
				}}
				date={processData?.LadleOpen ?? new Date()}
				lostStrand={selectedLostStrand}
				limitDates={
					processData?.LadleOpen
						? {
								start: processData.LadleOpen,
								end: processData.LadleClose ?? new Date(),
							}
						: undefined
				}
				processId={processData?.ProcessId ?? undefined}
			/>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
